import React, { useEffect, useState } from "react";
import Popup from "../../popup/index";
import Delimiter from "../../common/forms/delimiter/Delimiter";
import "./styles/index.scss";
import * as api from "../../../api/generated-api";
import DKFormTextInput from "../../common/widgets/formVariablesWidget/DKFormTextInput";

const AddPersonToDealForm = (props) => {
  const {
    errors,
    open,
    onClose,
    companyName,
    onAdd,
    onAddExisting,
    title = "Invite Member",
    getPersons,
    persons,
  } = props;
  const initialMember = {
    firstName: "",
    lastName: "",
    email: "",
  };

  const [newPerson, setNewPerson] = useState<api.PersonCreate>(initialMember);
  const [existingPerson, setExistingPerson] = useState<api.Person>();
  const [searchResult, setSearchResult] = useState<api.Person[]>([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const canAdd: boolean =
    !!newPerson.firstName && !!newPerson.lastName && !!newPerson.email;

  const clearStateAfterSave = () => {
    setExistingPerson(undefined);
    setNewPerson(undefined);
  };

  useEffect(() => {
    if (
      newPerson.email.length &&
      searchResult.map((person) => person.email).indexOf(newPerson.email) === -1
    ) {
      getPersons(newPerson.email);
    } else {
      setSearchResult([]);
    }
  }, [newPerson.email]);

  useEffect(() => {
    if (existingPerson) {
      newPerson.email = existingPerson.email;
      newPerson.firstName = existingPerson.firstName;
      newPerson.lastName = existingPerson.lastName;
      setSearchResult([]);
    }
  }, [existingPerson]);

  useEffect(() => {
    if (persons) {
      setSearchResult(persons);
    }
  }, [persons]);

  const handleChange = (e) => {
    if (e.target.name === "email") {
      setIsDisabled(false);
    }
    setNewPerson({ ...newPerson, [e.target.name]: e.target.value });
  };

  const close = () => {
    onClose();
    setIsDisabled(false);
    setNewPerson(initialMember);
  };

  return (
    <Popup isOpen={open} onClosePopup={close}>
      <div className="popup-container">
        <div className="invite-member-popup-container">
          <i className="close-icon" aria-hidden="true" onClick={close} />
          <div className="invite-member-popup-title">{title}</div>
          <div className="investor-company-name">for {companyName}</div>
          <Delimiter type="headline" shift="18" />
          <div className="form-field-container without-padding without-border">
            <DKFormTextInput
              className="deals-input invite-form"
              dataTestId="input-email-address"
              label="Email"
              name="email"
              type="text"
              fullWidth={true}
              onChange={handleChange}
              value={newPerson.email || ""}
              variant="outlined"
            />
            {errors && errors.email && <p className="error">{errors.email}</p>}
            {searchResult && !!searchResult.length && (
              <div className="clients-wrapper">
                <div className="clients-list">
                  {searchResult.map((person) => {
                    return (
                      <div
                        data-testid="row-existing-person"
                        key={`person_${person.email}`}
                        className="clients-list-item"
                        onMouseDown={() => {
                          setIsDisabled(true);
                          setExistingPerson(person);
                        }}
                      >
                        {person.email}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {isDisabled && (
              <div className="person-exists-container">
                <div className="person-exists">
                  <div className="checked-green-icon" />
                  <div className="description">
                    This user is already a member of Dealkit
                  </div>
                </div>
              </div>
            )}
            <DKFormTextInput
              className="deals-input invite-form"
              dataTestId="input-first-name"
              label="First Name"
              name="firstName"
              type="text"
              fullWidth={true}
              onChange={handleChange}
              value={newPerson.firstName}
              variant="outlined"
            />
            {errors && errors.first_name && (
              <p className="error">{errors.first_name}</p>
            )}
            <DKFormTextInput
              className="deals-input without-margin"
              dataTestId="input-last-name"
              label="Last Name"
              name="lastName"
              type="text"
              fullWidth={true}
              onChange={handleChange}
              value={newPerson.lastName}
              variant="outlined"
            />
            {errors && errors.last_name && (
              <p className="error">{errors.last_name}</p>
            )}
            <Delimiter type="internal" shift="18" />
            <div
              className={
                (canAdd && "invite-button") || "invite-button inactive"
              }
              data-testid="button-save-person"
              onClick={() => {
                if (canAdd) {
                  if (existingPerson) {
                    onAddExisting({
                      person_id: existingPerson.id,
                      first_name: existingPerson.firstName,
                      last_name: existingPerson.lastName,
                      email: existingPerson.email,
                    });
                    clearStateAfterSave();
                  } else if (newPerson) {
                    onAdd(newPerson);
                    clearStateAfterSave();
                  }
                  close();
                }
              }}
            >
              add
            </div>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default AddPersonToDealForm;
